import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { KomitentVozilo } from './komitent-vozilo';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-komitent-vozilo-modal-update',
  templateUrl: './komitent-vozilo-modal-update.component.html'
})
export class KomitentVoziloModalUpdateComponent
  extends BaseModalUpdateComponent<KomitentVozilo>
  implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<KomitentVozilo>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal, modalService);
  }

  ngOnInit() {
  }

}
